import React, {Component} from 'react';

export class CRMUsersTable extends Component {
    render() {
        if (this.props.users.length > 0) {
            return (
                <div className="table-box">
                    <table className="table table-striped">
                        <thead>
                        <tr>
                            <th>Email</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.renderUsers()}
                        </tbody>
                    </table>
                </div>
            )
        } else {
            return (
                <p>There are no users for this client</p>
            )
        }
    }

    renderUsers() {
        return this.props.users.map((user) => {
            return (
                <tr key={user.id}>
                    <td>{user.email}</td>
                </tr>
            );
        });
    }
}